import http from "../http-common";

const getAll = (loc) => {
  return http.get(`/v1/floors`);
};

const get = (id) => {
  return http.get(`/v1/floors/id/${id}`);
};

const create = (data) => {
  return http.post("/v1/floors", data);
};

const update = (id, data) => {
  return http.put(`/v1/floors/${id}`, data);
};

const remove = (id) => {
  return http.delete(`/v1/floors/${id}`);
};

const assignDevice = (data) => {
  return http.post("/v1/floors/assign", data);
};

const removeDevice = (floorId, deviceId) => {
  return http.delete(`/v1/floors/assign/${floorId}/${deviceId}`);
};

export default {
  getAll,
  get,
  create,
  update,
  remove,
  assignDevice,
  removeDevice,
};
